import {
  ExternalComercialDTO,
  GeneralInvestmentReportDTO,
  OperationValidationResponse,
  OperationValidationRequest,
  AgentActionPlanDTO,
  AgentActionRequestDTO,
  ReqOpsDetailsDTO,
  OperationDetailRequestDTO,
  ReqIncentiveDetailsDTO,
  ReqIncentiveDetailsDTOResponse,
  ActionAgentReportResponseDTO,
} from './../models/control-panel.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import {
  AgentStatsReportDTO,
  AgentStatsRequestDTO,
  InvestDetailOperationRequestDTO,
  InvestmentByProductsDTO,
  GeneralInvestmentRequestDTO,
  InvestProductsDTO,
} from '../models/control-panel.model';

@Injectable({
  providedIn: 'root',
})
export class ControlPanelServiceApi {
  constructor(readonly _http: HttpClient) {}

  getExternalCommercialsByFilter(externalCommercial: ExternalComercialDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelExternalCommercialByFilter,
      externalCommercial
    );
  }

  getDocumentStatus(): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelDocumentStatus,
      null
    );
  }

  getProducts(parameter: any): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelProduct,
      parameter
    );
  }

  getArticles(parameter: any): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelArticles,
      parameter
    );
  }

  //CONSULTS

  getInvestDetail(parameter: InvestDetailOperationRequestDTO): Observable<any> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelAgents,
      parameter
    );
  }

  getProductInvestment(parameter: InvestProductsDTO): Observable<InvestmentByProductsDTO> {
    return this._http.post<InvestmentByProductsDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelInvestProduct,
      parameter
    );
  }

  getAgentStatistics(parameter: AgentStatsRequestDTO): Observable<AgentStatsReportDTO> {
    return this._http.post<AgentStatsReportDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelAgentStatistics,
      parameter
    );
  }

  getOrigins(): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(environment.URL_BASE_REQUEST + environment.subUrlControlPanelOrigins, null);
  }

  getGeneralInvestment(request: GeneralInvestmentRequestDTO): Observable<GeneralInvestmentReportDTO> {
    return this._http.post<GeneralInvestmentReportDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelInvestments,
      request
    );
  }

  getOperationValidation(request: OperationValidationRequest): Observable<OperationValidationResponse> {
    return this._http.post<OperationValidationResponse>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelValidationOperations,
      request
    );
  }
  getActionAgentPlan(request: AgentActionPlanDTO): Observable<ActionAgentReportResponseDTO> {
    return this._http.post<ActionAgentReportResponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelActionPlan,
      request
    );
  }

  getExternalCommercialByFilter(request: AgentActionRequestDTO): Observable<CommonDataDTO[]> {
    return this._http.post<CommonDataDTO[]>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPanelExternalCommercialByCase,
      request
    );
  }

  getStatusList(): Observable<CommonDataDTO[]> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlControlPanelStatus, null);
  }

  getOperationDetail(request: OperationDetailRequestDTO): Observable<ReqOpsDetailsDTO[]> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlControlPanelOperationDetail, request);
  }

  getPenaltyDetail(parameter: ReqIncentiveDetailsDTO): Observable<ReqIncentiveDetailsDTOResponse> {
    return this._http.post<ReqIncentiveDetailsDTOResponse>(
      environment.URL_BASE_REQUEST + environment.subUrlControlPenaltyDetailReport,
      parameter
    );
  }
}
